var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 20.199C8.54654 20.4528 8.24554 20.6542 7.91421 20.7916C7.58288 20.9291 7.22771 20.9998 6.869 21H3V17.156C3 16.432 3.288 15.737 3.8 15.225M8.8 20.199L3.8 15.225M8.8 20.199L18.774 10.221M3.8 15.225L13.784 5.22995L15.21 3.80196C15.4638 3.54781 15.7651 3.34618 16.0968 3.20857C16.4286 3.07097 16.7842 3.00009 17.1433 3C17.5024 2.99991 17.8581 3.0706 18.1899 3.20803C18.5217 3.34546 18.8231 3.54695 19.077 3.80096L20.203 4.92796C20.7155 5.44049 21.0035 6.13563 21.0035 6.86045C21.0035 7.58528 20.7155 8.28042 20.203 8.79296L18.774 10.221M18.774 10.221L13.783 5.22995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.ca0692f8775fcdd190f0e3ce4672c33b.svg";
export { ForwardRef as ReactComponent };